// Shopify never adds a Buy X Get Y item by itself, so one gift stays in the cart while the brand total
// is over the minimum. The switch, brand, minimum and gift come from the theme editor (snippets/mini-cart.liquid).
(() => {
  const gift = window.theme.freeGift;

  // Looked up each time, since ShipInsure swaps the checkout button for a clone
  const setCheckoutDisabled = (isDisabled) => {
    document.querySelectorAll('button[name="checkout"]').forEach((button) => {
      button.disabled = isDisabled;
    });
  };

  // Resolves with the cart once its gift line matches the brand total
  window.theme.syncFreeGift = (cart) => {
    const giftLines = cart.items.filter((item) => item.variant_id === gift.variantId);
    const brandTotal = cart.items
      .filter((item) => item.variant_id !== gift.variantId && gift.vendors.includes(item.vendor))
      .reduce((total, item) => total + item.final_line_price, 0);
    // Switched off, the promotion is over: a gift already in a cart comes out too
    const giftQuantity = gift.isOn && brandTotal > gift.minimum ? 1 : 0;
    const hasRightGift = giftQuantity ? giftLines.length === 1 && giftLines[0].quantity === 1 : giftLines.length === 0;
    if (hasRightGift) return cart;

    const updates = {};
    giftLines.forEach((item, index) => {
      updates[item.key] = index === 0 ? giftQuantity : 0;
    });
    if (!giftLines.length) updates[gift.variantId] = giftQuantity;

    // A shopper who clicks checkout while the gift is on its way would leave without it
    setCheckoutDisabled(true);
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    })
      .then((response) => response.json())
      // A gift Shopify refuses (throttled) leaves the cart as it was; the next cart change tries again
      .then(
        (updatedCart) => (updatedCart.items ? updatedCart : cart),
        () => cart
      )
      .finally(() => setCheckoutDisabled(false));
  };
})();
